var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditResume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1762_20417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.403 8.81775C13.0343 8.81775 12.7363 9.11646 12.7363 9.48438V14.8177C12.7363 15.1851 12.4376 15.4844 12.0697 15.4844H2.73633C2.36829 15.4844 2.0697 15.1851 2.0697 14.8177V5.48438C2.0697 5.11707 2.36829 4.81775 2.73633 4.81775H8.0697C8.43835 4.81775 8.73633 4.51904 8.73633 4.15112C8.73633 3.78308 8.43835 3.48438 8.0697 3.48438H2.73633C1.63367 3.48438 0.736328 4.38171 0.736328 5.48438V14.8177C0.736328 15.9204 1.63367 16.8177 2.73633 16.8177H12.0697C13.1724 16.8177 14.0697 15.9204 14.0697 14.8177V9.48438C14.0697 9.11572 13.7716 8.81775 13.403 8.81775Z",
    fill: "#FE8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98708 8.21069C6.94045 8.25732 6.90908 8.31665 6.89577 8.38062L6.42446 10.738C6.40248 10.8473 6.43715 10.96 6.51577 11.0393C6.57912 11.1027 6.66445 11.1366 6.75185 11.1366C6.77309 11.1366 6.79519 11.1346 6.81716 11.13L9.17385 10.6587C9.23916 10.6453 9.29848 10.614 9.3445 10.5673L14.6192 5.2926L12.2625 2.93604L6.98708 8.21069Z",
    fill: "#FE8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.248 1.30588C15.5981 0.655853 14.5408 0.655853 13.8914 1.30588L12.9688 2.22849L15.3254 4.58518L16.248 3.66245C16.5627 3.34848 16.7361 2.92978 16.7361 2.48447C16.7361 2.03915 16.5627 1.62045 16.248 1.30588Z",
    fill: "#FE8700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1762_20417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.736328 0.787109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditResume);
export default __webpack_public_path__ + "static/media/editResume.05eec48d5dab6dce6936313bb2a9a670.svg";
export { ForwardRef as ReactComponent };